import * as angular from 'angular';
import { ThemeService } from './mx-theme.service';
import { ColorService } from './color.service';
import { MxUnauthThemeDirective } from './mx-unauth-theme.directive';
import { MxCssVariablesDirective } from './mx-css-variables.directive';
import { MxThemePreviewComponent } from './mx-theme-preview/mx-theme-preview.component';

export const themesModule = angular
	.module('mx.sb.Themes', [])
	.service('mx.app.ColorService', ColorService)
	.service('mx.app.ThemeService', ThemeService)
	.factory('mx.SolutionBuilderAgent.ThemeService', [
		'mx.app.ThemeService',
		//legacy service name for mx.EpsUux.Controls extension. Should be removed when mx.EpsUux.Controls uses public module
		function deprecatedThemeService(themeService: ThemeService) {
			return themeService;
		},
	])
	.directive('mxUnauthTheme', MxUnauthThemeDirective)
	.directive('mxCssVariables', MxCssVariablesDirective)
	.component('mxThemePreview', MxThemePreviewComponent);
